/* Native anchors and disclosures remain usable without JavaScript. */
(() => {
  const initialize = scope => scope.querySelectorAll('[data-research-document]').forEach(root => {
    if (root.dataset.researchReady) return;
    root.dataset.researchReady = 'true';
    const nav = root.querySelector('.erd-nav');
    if (!nav) return;
    const links = [...nav.querySelectorAll('a')];
    const chapters = [...root.querySelectorAll('.erd-chapter')];
    const progress = root.querySelector('.erd-progress');
    if (progress) progress.hidden = false;
    const reveal = target => {
      for (let parent = target.parentElement; parent && root.contains(parent); parent = parent.parentElement) {
        if (parent.tagName === 'DETAILS') parent.open = true;
      }
    };
    root.addEventListener('click', event => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest('a[href^="#"]');
      if (!link) return;
      const target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
      if (!target || !root.contains(target)) return;
      reveal(target);
      target.setAttribute('tabindex', '-1');
      target.focus({preventScroll:true});
    });
    const revealHash = () => {
      let id;
      try { id = decodeURIComponent(location.hash.slice(1)); } catch { return; }
      const target = document.getElementById(id);
      if (target && root.contains(target)) {
        reveal(target);
        requestAnimationFrame(() => target.scrollIntoView({block:'start'}));
      }
    };
    window.addEventListener('hashchange', revealHash);
    if (location.hash) revealHash();
    let frame;
    let active;
    const sync = () => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = null;
        if (!root.isConnected) return;
        const header = document.querySelector('.shopify-section-header-sticky');
        const headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
        const top = Math.min(headerBottom, 160);
        root.style.setProperty('--research-nav-top', `${top}px`);
        const offset = top + nav.getBoundingClientRect().height + 40;
        let current;
        for (const chapter of chapters) {
          if (chapter.getBoundingClientRect().top <= offset) current = chapter;
          else break;
        }
        if (current !== active) {
          active = current;
          links.forEach(link => {
            if (current && link.hash === `#${current.id}`) link.setAttribute('aria-current','location');
            else link.removeAttribute('aria-current');
          });
          const link = links.find(link => link.hasAttribute('aria-current'));
          if (link) {
            const scroller = link.parentElement;
            const left = link.getBoundingClientRect().left - scroller.getBoundingClientRect().left + scroller.scrollLeft;
            if (left < scroller.scrollLeft || left + link.offsetWidth > scroller.scrollLeft + scroller.clientWidth) {
              scroller.scrollLeft = Math.max(0,left - 12);
            }
          }
        }
        if (progress) {
          const rect = root.getBoundingClientRect();
          const ratio = Math.max(0,Math.min(1,-rect.top / Math.max(1,rect.height-window.innerHeight)));
          progress.setAttribute('aria-valuenow',String(Math.round(ratio*100)));
          progress.firstElementChild.style.transform = `scaleX(${ratio})`;
        }
      });
    };
    window.addEventListener('scroll',sync,{passive:true});
    window.addEventListener('resize',sync);
    root.addEventListener('toggle',sync,true);
    if ('ResizeObserver' in window) new ResizeObserver(sync).observe(root);
    sync();
  });
  initialize(document);
  document.addEventListener('shopify:section:load',event => initialize(event.target));
})();
